import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const navigationItems = [
  { key: 'navigation', label: '师友导航', path: '/', matches: (pathname) => pathname === '/' },
  {
    key: 'products',
    label: '产品中心',
    path: '/products',
    matches: (pathname) => pathname.startsWith('/products') || pathname === '/product' || pathname === '/wechat'
  },
  { key: 'guide', label: '使用指南', path: '/guide', matches: (pathname) => pathname.startsWith('/guide') },
  { key: 'download', label: '下载中心', path: '/download', matches: (pathname) => pathname.startsWith('/download') }
];

const PublicHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();
  const displayName = user?.displayName || user?.display_name || user?.name || user?.username || '教师';

  return (
    <header className="public-site-header">
      <div className="public-site-header-inner">
        <button type="button" className="public-site-brand" onClick={() => navigate('/')} aria-label="教室小喇叭官网首页">
          <img src="/xlb-logo.png" alt="教室小喇叭 Logo" />
          <span><strong>教室小喇叭</strong><small>学校 · 教师 · 班级协同</small></span>
        </button>

        <nav className="public-site-nav" aria-label="官网主导航">
          {navigationItems.map((item) => (
            <button
              type="button"
              key={item.key}
              className={item.matches(location.pathname) ? 'active' : ''}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="public-site-actions">
          {isAuthenticated ? (
            <div className="public-site-user-actions">
              <span className="public-site-user-chip">
                <span className="public-site-user-avatar">{String(displayName).trim().slice(0, 1) || '师'}</span>
                <span className="public-site-user-name">{displayName}</span>
              </span>
              <button className="public-site-action primary" type="button" onClick={() => navigate('/dashboard')}>进入工作台</button>
            </div>
          ) : (
            <div className="public-site-guest-actions">
              <button className="public-site-action" type="button" onClick={() => navigate('/login')}>登录</button>
              <button className="public-site-action primary" type="button" onClick={() => navigate('/register')}>注册</button>
            </div>
          )}

          <details className="public-site-mobile-menu">
            <summary aria-label="打开导航菜单">≡</summary>
            <nav className="public-site-mobile-menu-panel" aria-label="移动端官网导航">
              {navigationItems.map((item) => (
                <button
                  type="button"
                  key={item.key}
                  className={item.matches(location.pathname) ? 'active' : ''}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </details>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
